import { Card, Col, Divider, Row, Typography } from 'antd';
import { StyleSheet } from "../../../StyleSheet";
import { Key, useState } from 'react';
import { postMeganQuestion } from '../../../methods/Methods';
import { RequestMeganQuestion } from '../../../types/common';
import MeganLoading from '../../../components/MeganLoading';
import MarkdownPreviewer from '../../../common/MarkdownPreviewer';

const { Text } = Typography;

interface ItemProps {
    key: Key;
    prompt: string;
    question: string;
}

interface ListAccordionProps {
    idCliente: string;
    items: Array<ItemProps>;
};

const ListItemAccordionFaq = (props: ListAccordionProps) => {
    const { idCliente, items } = props;
    const [showElement, setShowElement] = useState<Key>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [answer, setAnswer] = useState<string>("");
    const [isError, setIsError] = useState<boolean>(false);

    const getAnswer = async (prompt: string) => {
        setIsLoading(true);
        setIsError(false);

        let askQuestion: RequestMeganQuestion = {
            question: prompt
        };

        await postMeganQuestion(idCliente, askQuestion)
            .then((response) => {
                if (response.data.data[0].success) {
                    setAnswer(response.data.data[0].message);
                    setIsError(false);
                } else {
                    setAnswer(response.data.data[0].message);
                    setIsError(true);
                }
            })
            .catch(() => {
                setAnswer("No fue posible realizar la consulta, intente más tarde.");
                setIsError(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handlePress = (key: Key, prompt: string) => {
        if (key !== showElement) {
            // Solo llama a getAnswer si el acordeón se está abriendo
            getAnswer(prompt);
        }
        setShowElement(key === showElement ? "" : key);
    };

    return (
        <div>
            {items.map(item => (
                <Card
                    key={item.key}
                    style={styles.cardStyles}
                    bodyStyle={styles.cardBody}
                >
                    <Row
                        gutter={[10, 10]}
                        style={{ cursor: 'pointer' }}
                        onClick={() => handlePress(item.key, item.prompt)}
                    >
                        <Col span={24} style={{ textAlign: "center" }} >
                            <Text style={{ color: "#0055b9", fontWeight: 600 }}>{item.question}</Text>
                        </Col>
                        <Col span={24} style={{ marginBottom: 10 }}>
                            {item.key === showElement && (
                                isLoading ? <MeganLoading /> :
                                    isError ?
                                        <Text style={{ color: "red", textAlign: "center" }}>{answer}</Text>
                                        :
                                        <MarkdownPreviewer
                                            mdSource={answer}
                                            textStyle={{ textAlign: "justify" }}
                                        />
                            )}
                        </Col>
                    </Row>
                    <Divider style={styles.lineDivider} />
                </Card>
            ))}
        </div>
    );
};

const styles = StyleSheet.create({
    cardStyles: {
        border: 0,
        display: 'flex',
        justifyContent: 'center',
    },
    cardBody: {
        width: "80%",
        padding: 10
    },
    lineDivider: {
        backgroundColor: '#0055b9',
        margin: "5px 0"
    },
});

export default ListItemAccordionFaq;
